/* ============================================================
   OBF theme JS — small, self-contained enhancements.
   Loaded once from layout/theme.liquid (defer).

   Product-card colour carousels: on desktop a mouse user can't see the
   hidden scrollbar, so they can't tell there are more colours or reach
   them. This wires each `.obf-swatches` scroller for:
     • click-and-drag to scroll (pointer events, mouse only)
     • vertical wheel → horizontal scroll while hovering the strip
     • an `data-obf-overflow` attribute (="start" | "middle" | "end" | "")
       so CSS can show left/right fade hints ONLY when it actually overflows.
   Touch devices keep native momentum scrolling; we don't hijack them.
   Idempotent + re-runs after AJAX collection paginate/filter swaps.
   ============================================================ */
(function () {
  'use strict';

  var SEL = '.product-card .product-card-swatches--container.obf-swatches';

  function updateOverflowState(el) {
    var max = el.scrollWidth - el.clientWidth;
    if (max <= 1) {
      el.removeAttribute('data-obf-overflow');
      return;
    }
    var x = el.scrollLeft;
    var state = 'middle';
    if (x <= 1) state = 'start';
    else if (x >= max - 1) state = 'end';
    el.setAttribute('data-obf-overflow', state);
  }

  function enhance(el) {
    if (el.__obfSwatchWired) return;
    el.__obfSwatchWired = true;

    // Reflect overflow state for the CSS fade hints.
    updateOverflowState(el);
    el.addEventListener('scroll', function () { updateOverflowState(el); }, { passive: true });

    // Vertical wheel → horizontal scroll (only when there's something to scroll).
    el.addEventListener('wheel', function (e) {
      var max = el.scrollWidth - el.clientWidth;
      if (max <= 1) return;
      // Let genuine horizontal wheels pass through; convert vertical ones.
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var before = el.scrollLeft;
      el.scrollLeft += e.deltaY;
      // Only swallow the page-scroll if we actually moved (so the page can
      // still scroll once the strip hits its end).
      if (el.scrollLeft !== before) e.preventDefault();
    }, { passive: false });

    // Click-and-drag to scroll — mouse pointers only (touch keeps native).
    var down = false, startX = 0, startLeft = 0, moved = false;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false;
      startX = e.clientX;
      startLeft = el.scrollLeft;
    });

    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) {
        moved = true;
        el.classList.add('obf-swatches--dragging');
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
      }
      el.scrollLeft = startLeft - dx;
    });

    function endDrag() {
      down = false;
      el.classList.remove('obf-swatches--dragging');
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', endDrag);

    // Suppress the swatch click (variant image swap / navigation) if the
    // pointerup was the end of a drag, not a real click.
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  // Re-scan after the theme swaps product grids (filter / paginate / load-more).
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) { scan(document); break; }
    }
  });
  if (document.body) {
    mo.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }

  // Keep overflow flags correct on resize.
  window.addEventListener('resize', function () { scan(document); document.querySelectorAll(SEL).forEach(updateOverflowState); }, { passive: true });
})();
